import { useDispatch, useSelector } from "react-redux";

export const useSelectorApp = (state) => useSelector(state);
export const useDispatchApp = () => useDispatch();
